<script>
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Lead from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Grid from '@/Elements/Grids/Basic.svelte';
  import Card from '@/Elements/Shapes/Cards/Preview.svelte';
  // import Boost from '@/Elements/Actions/Buttons/Boost.svelte';

  export let envision;

  let meta = envision.meta;
  let title = envision.title;
  let text = envision.text;
  let projects = envision.projects;
</script>

<style></style>

<section id="projects" class="pt-12 pb-24 bg-white">
  <Container>
    <div class="flex flex-col space-y-3 px-var py-6">
      <div class="space-y-1">
        <Meta>{meta}</Meta>
        <Title>{title}</Title>
      </div>
      <Lead>{text}</Lead>
    </div>
    <div class="px-var">
      <Grid>
        {#each projects as item}
          <Card {item}></Card>
        {/each}
      </Grid>
    </div>
  </Container>
</section>